import PropTypes from 'prop-types';
import React from 'react';
import { find } from 'lodash';

export default class extends React.Component {
  static propTypes = {
    placeholder: PropTypes.string,
  };

  static defaultProps = {
    valueOptions: [],
  };

  constructor(props) {
    super(props);
    const defaultValue = '';
    const defaultValueOption = {
      value: defaultValue,
      option: props.placeholder,
    };
    const valueOptions = [defaultValueOption].concat(props.valueOptions);

    const initialValue = props.defaultValue || defaultValue;
    const initialValueOption =
      find(valueOptions, item => {
        return item.value === initialValue;
      }) || defaultValueOption;

    this.state = {
      ...initialValueOption,
      valueOptions,
    };
  }

  handleSelectChange = (event) => {
    const value = event.target.value;
    const option = find(this.state.valueOptions, item => {
      return item.value === value;
    }).option;

    this.setState({
      value,
      option,
    });
  };

  render() {
    return (
      <div
        className='selectDropdown'
        style={{
          fontFamily: 'pp-sans-small-regular',
          color: '#6c7378',
          fontSize: '14px',
          lineHeight: '1.3',
        }}
      >
        <div className='textViewport'>{this.state.option}</div>
        <select
          name={this.props.name}
          className='selectMenu'
          onChange={this.handleSelectChange}
          value={this.state.value}
        >
          {this.state.valueOptions.map((item, index) => {
            if (index === 0) {
              return (
                <option
                  style={{ color: '#6c7378' }}
                  value=''
                  key={`select-${this.props.name}-${item.value}`}
                  default
                >
                  {item.option}
                </option>
              );
            }
            return (
              <option
                style={{ color: '#6c7378' }}
                value={item.value}
                key={`select-${this.props.name}-${item.value}`}
              >
                {item.option}
              </option>
            );
          })}
        </select>
        <span className='icon icon-smallest icon-arrow-down-small dropArrow' />
      </div>
    );
  }
}
